const action = name => `ADV.FINANCIAL_PLAN_WARNING.${name}`;

export const WARNING_TYPE_NEGATIVE_CASHFLOW = 'NEGATIVE_CASHFLOW';

export const SHOW = action('SHOW');
export const HIDE = action('HIDE');
export const HIDE_ALL = action('HIDE_ALL');

export const showNegativeCashflow = (warningMessage, clientId) => ({
  type: SHOW,
  warningType: WARNING_TYPE_NEGATIVE_CASHFLOW,
  warningMessage,
  clientId,
});

export const hide = (key, clientId) => ({
  type: HIDE,
  clientId,
  key,
});

export const hideAll = clientId => ({
  type: HIDE_ALL,
  clientId,
});
